import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize, forkJoin } from 'rxjs';
import { BusinessLineService } from 'src/app/api/services/business-line.service';
import { ProfesionService } from 'src/app/api/services/proffesion.service';
import { MESSAGES } from 'src/app/core/constant/messages';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { ModalFormComponent } from 'src/app/shared/component/modal-form/modal-form.component';
import { TableGenericComponent } from 'src/app/shared/component/table-generic/table-generic.component';
import {
  FormFieldConfig,
  TableAction,
  TableColumn,
} from 'src/app/shared/model/admin';
import { BussinesLine } from 'src/app/shared/model/bussiness-line';
import { ToastService } from 'src/app/shared/service/toast.service';
import { handleApiError } from 'src/app/shared/util/handle-api-error';

@Component({
  selector: 'app-bussines-line',
  imports: [
    TableGenericComponent,
    CommonModule,
    LoadingComponent,
    ModalFormComponent,
  ],
  templateUrl: './bussines-line.component.html',
  styles: ``,
})
export class BussinesLineComponent {
  mostrarModalAgregar: boolean = false;
  mostrarModalEditar: boolean = false;
  loadingAgregar: boolean = false;
  loadingEditar: boolean = false;
  loadingBusinessLines: boolean = false;
  editarSeleccionada?: any;

  businessLines: BussinesLine[] = [];

  formAgregar!: FormGroup;
  formEditar!: FormGroup;

  columns: TableColumn[] = [
    { header: 'Nombre', field: 'description' },
    { header: 'Estado', field: 'state' },
  ];
  actions: TableAction[] = ['edit'];

  fieldsAgregar: FormFieldConfig[] = [
    {
      name: 'name',
      label: 'Nombre',
      placeholder: 'Nombre de la línea de negocio',
    },
  ];
  fieldsEditar: FormFieldConfig[] = [
    {
      name: 'name',
      label: 'Nombre',
      placeholder: 'Nombre de la línea de negocio',
    },
    {
      name: 'state',
      label: 'Estado',
      type: 'select',
      options: [
        { label: 'Activo', value: 'activo' },
        { label: 'Inactivo', value: 'inactivo' },
      ],
    },
  ];

  constructor(
    private fb: FormBuilder,
    private businessLineService: BusinessLineService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.initForms();
    this.cargarBusinessLines();
  }

  private initForms(): void {
    this.formAgregar = this.fb.group({ name: ['', Validators.required] });
    this.formEditar = this.fb.group({
      name: ['', Validators.required],
      state: ['', Validators.required],
    });
  }

  private cargarBusinessLines(): void {
    this.loadingBusinessLines = true;
    this.businessLineService
      .getAll()
      .pipe(
        handleApiError(this.toastService, MESSAGES.BUSINESSLINE.GET_ALL_ERROR),
        finalize(() => (this.loadingBusinessLines = false))
      )
      .subscribe((res: any) => {
        this.businessLines = res.dto?.businessLines || [];
      });
  }

  openModal(type: 'add' | 'edit', businessLine?: BussinesLine): void {
    this.mostrarModalAgregar = false;
    this.mostrarModalEditar = false;
    this.editarSeleccionada = undefined;

    if (type === 'add') {
      this.formAgregar.reset();
      this.mostrarModalAgregar = true;
      return;
    }

    if (type === 'edit' && businessLine) {
      this.editarSeleccionada = businessLine;
      this.formEditar.setValue({
        name: businessLine.description,
        state: businessLine.state,
      });
      this.mostrarModalEditar = true;
    }
  }

  crearBusinessLine(): void {
    if (this.formAgregar.invalid) {
      this.formAgregar.markAllAsTouched();
      return;
    }

    this.loadingAgregar = true;
    const { name } = this.formAgregar.value;

    this.businessLineService
      .createBusinessLine(name)
      .pipe(
        handleApiError(this.toastService, MESSAGES.BUSINESSLINE.CREATE_ERROR),
        finalize(() => (this.loadingAgregar = false))
      )
      .subscribe(() => {
        this.toastService.showMessages('success', [
          MESSAGES.BUSINESSLINE.CREATE_SUCCESS,
        ]);
        this.cargarBusinessLines();
        this.mostrarModalAgregar = false;
      });
  }

  actualizarBusinessLine(): void {
    if (this.formEditar.invalid || !this.editarSeleccionada) {
      this.formEditar.markAllAsTouched();
      return;
    }

    this.loadingEditar = true;
    const { name, state } = this.formEditar.value;
    const idBusinessLine = this.editarSeleccionada.idBusinessLine;

    const nombre$ = this.businessLineService.updateBusinessLine(
      idBusinessLine,
      name
    );

    const estado$ = this.businessLineService.updateStateByIdBusinessLine(
      idBusinessLine,
      state
    );

    forkJoin([nombre$, estado$])
      .pipe(
        handleApiError(this.toastService, MESSAGES.BUSINESSLINE.UPDATE_ERROR),
        finalize(() => (this.loadingEditar = false))
      )
      .subscribe(() => {
        this.toastService.showMessages('success', [
          MESSAGES.BUSINESSLINE.UPDATE_SUCCESS,
        ]);
        this.cargarBusinessLines();
        this.mostrarModalEditar = false;
      });
  }
}
